import React from 'react';
import ReactDOM from 'react-dom';
import { ShippingCurrencyModal } from './ShippingCurrencyModal';

// Mount shipping currency modal once in the header
const renderShippingCurrencyModal = () => {
  const mountNode = document.querySelector('[react-render-target="ShippingCurrencyModal"]');
  if (mountNode) ReactDOM.render(<ShippingCurrencyModal />, mountNode);
  else console.warn('missing render target: ShippingCurrencyModal');
};

export const initShippingCurrencyModal = () => {
  renderShippingCurrencyModal();
};
